import React, { useEffect, useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const AddDocumentRequestTour = ({ forceStart, onTourEnd }) => {
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (forceStart) {
      setRun(false);
    }

    const seenTour = localStorage.getItem('tour_seen_add_document');

    if (!forceStart && seenTour) return;

    const timer = setTimeout(() => {
      setSteps([
        {
          target: '.tour-doc-title',
          content: 'Provide a clear, descriptive title for the document you are attaching or requesting.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-doc-dropzone',
          content: 'You can drag and drop your file directly into this box, or click it to browse your computer.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-doc-submit',
          content: 'Once the file is uploaded, click Submit to finalize the request.',
          placement: 'top',
          disableBeacon: true,
          disableScrolling: true
        }
      ]);
      
      setRun(true);
    }, 400); 

    return () => clearTimeout(timer);
  }, [forceStart]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      if (onTourEnd) onTourEnd();
      localStorage.setItem('tour_seen_add_document', 'true');
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      hideCloseButton={true}
      callback={handleJoyrideCallback}
      styles={{
        options: { primaryColor: '#000000', textColor: '#000000', zIndex: 10000 },
        tooltip: { borderRadius: '8px', padding: '20px' },
        buttonNext: { backgroundColor: '#3c8138', borderRadius: '4px' },
        buttonBack: { color: '#3c8138' }
      }}
    />
  );
};

export default AddDocumentRequestTour;